import { Routes, Route } from "react-router-dom";
import { Home } from "../pages/Home";
import { NoMatch } from "../pages/NoMatch";
import { PublicLayout } from "../layouts/PublicLayout";
import { Search } from "../pages/Search";
import { Property } from "../pages/Property";
import { useAuth } from "../hooks/useAuth";
const Router = ({ application }) => {
    const { user, isAuthenticated, getUserDetailsNotAsync } = useAuth();
    const userData = getUserDetailsNotAsync();
    const path = "";
    return (
        <Routes>
            <Route element={<PublicLayout />}>
                <Route path={path + "/"} element={<Home />} />
                <Route path={path + "/listing-search"} element={<Search />}></Route>
                <Route path={path + "/listing-search/markets/:market"} element={<Search />}></Route>
                <Route path={path + "/property/:recordId"} element={<Property />}></Route>
                <Route path="*" element={<NoMatch />} />
            </Route>
        </Routes>
    );
};

export { Router };
